import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./filters.module.scss";

const Filters = ({ filters, sorts, billed, viewMode, count, search }) => {
  const { t } = useTranslation();

  return (
    <div className={`${styles.wrap}`}>
      <div className={`${styles.left}`}>
        {count != null && (
          <span>
            <span className={styles.label}>{t("showing")}</span>
            &nbsp;
            <strong>{t("ideasCount", { count })}</strong>
          </span>
        )}
        {filters && (
          <span>
            <span className={styles.label}>{t("status")}</span>
            &nbsp;{filters}
          </span>
        )}
        {sorts && (
          <span>
            <span className={styles.label}>{t("sortBy")}</span>
            &nbsp;{sorts}
          </span>
        )}
        {search && (
          <span>
            <span className={styles.label}>{t("containing")}</span>
            &nbsp;<strong>&ldquo;{search}&rdquo;</strong>
          </span>
        )}
        {billed && (
          <span>
            {t("billed")} &nbsp;{billed}
          </span>
        )}
      </div>
      {viewMode && <div className={`${styles.right}`}>{viewMode}</div>}
    </div>
  );
};

Filters.propTypes = {
  filters: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  sorts: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  pay: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  viewMode: PropTypes.node,
  count: PropTypes.number,
  search: PropTypes.string,
  onClearSearch: PropTypes.func,
};

export default Filters;
